// extracted by mini-css-extract-plugin
module.exports = {"link":"Anchor-module--link--Rh04n"};